import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { map, Observable, of } from 'rxjs';
import { IRessourceCategory } from '../models/ressource-category';
import { RessourceCategoryService } from '../services/ressource-category.service';

@Injectable({
  providedIn: 'root'
})
export class RessourceCategoryResolver  {

  constructor(
    private ressourceCategoryService : RessourceCategoryService
  ){}

  resolve(
    route: ActivatedRouteSnapshot, 
    state: RouterStateSnapshot
    ): Observable<IRessourceCategory[]> {
    return this.ressourceCategoryService.searchRessourceCategories({pageNumber: 0, pageSize: 999999})
    .pipe(
      map(response => response.data)
    )
  }
}
